import Lottie from "lottie-react";
import React from "react";
import serverErrorAnim from "../assets/404Animation.json";
import Footer from "../Fotter";

const PageNotFound = () => {
    return (
        <div >
            <div className="flex flex-col items-center h-full justify-center min-h-[70vh] text-center">
                <div className="w-72 max-w-full">
                    <Lottie animationData={serverErrorAnim} loop autoplay />
                </div>

                <h1 className="text-3xl font-bold text-red-600 mt-4">Page Not Found</h1>
                <p className="text-base mt-2 text-gray-600">
                    Something went wrong on our end. Please try again later.
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default PageNotFound;
